import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { Client } from "../requests";
import EditClientForm from './EditClientForm';

const EditClientPage = (props) => {

  const navigate = useNavigate()

  const location = useLocation()
  const fromClientDetails = location.state
  
  const updateClient = (id, params) => {
    Client.update(id, params).then((c) => {
      navigate(`/clients/${c.id}`)
    })
  }
  return (
    <>
      <div>
        <h1 className="text-center">Edit client page</h1>
        <EditClientForm
          updateClient={updateClient}
          id={fromClientDetails.fromClientDetails.id}
          first_name={fromClientDetails.fromClientDetails.first_name}
          last_name={fromClientDetails.fromClientDetails.last_name}
          dietary_restrictions={fromClientDetails.fromClientDetails.dietary_restrictions}
          languages={fromClientDetails.fromClientDetails.languages}
          comments={fromClientDetails.fromClientDetails.comments}
          admin_comment={fromClientDetails.fromClientDetails.admin_comment}
          family_size={fromClientDetails.fromClientDetails.family_size}
          new_client={fromClientDetails.fromClientDetails.new_client}
          release_signed={fromClientDetails.fromClientDetails.release_signed}
          end_date={fromClientDetails.fromClientDetails.end_date}
          cancelled_date={fromClientDetails.fromClientDetails.cancelled_date}
          interview_date={fromClientDetails.fromClientDetails.interview_date}
          date_of_birth={fromClientDetails.fromClientDetails.date_of_birth}
          address={fromClientDetails.fromClientDetails.address}
          city={fromClientDetails.fromClientDetails.city}
          postal_code={fromClientDetails.fromClientDetails.postal_code}
          phone_number={fromClientDetails.fromClientDetails.phone_number}
          email={fromClientDetails.fromClientDetails.email}
          start_date={fromClientDetails.fromClientDetails.start_date}
          last_visit={fromClientDetails.fromClientDetails.last_visit}
          employment={fromClientDetails.fromClientDetails.employment}
          social_services={fromClientDetails.fromClientDetails.social_services}
          child_tax_credit={fromClientDetails.fromClientDetails.child_tax_credit}
          support_maintenance={fromClientDetails.fromClientDetails.support_maintenance}
          ei_benefits={fromClientDetails.fromClientDetails.ei_benefits}
          wcb_benefits={fromClientDetails.fromClientDetails.wcb_benefits}
          pension={fromClientDetails.fromClientDetails.pension}
          room_and_board={fromClientDetails.fromClientDetails.room_and_board}
          rent={fromClientDetails.fromClientDetails.rent}
          mortgage={fromClientDetails.fromClientDetails.mortgage}
          property_insurance={fromClientDetails.fromClientDetails.property_insurance}
          property_taxes={fromClientDetails.fromClientDetails.property_taxes}
          strata={fromClientDetails.fromClientDetails.strata}
          laundry={fromClientDetails.fromClientDetails.laundry}
          hydro={fromClientDetails.fromClientDetails.hydro}
          gas={fromClientDetails.fromClientDetails.gas}
          phone={fromClientDetails.fromClientDetails.phone}
          cable={fromClientDetails.fromClientDetails.cable}
          internet={fromClientDetails.fromClientDetails.internet}
          medical={fromClientDetails.fromClientDetails.medical}
          car_payment={fromClientDetails.fromClientDetails.car_payment}
          car_insurance={fromClientDetails.fromClientDetails.car_insurance}
          other_income={fromClientDetails.fromClientDetails.other_income}
          other_expenses={fromClientDetails.fromClientDetails.other_expenses}
        />
      </div>
    </>
  )
}

export default EditClientPage